<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="84"
    height="80"
    viewBox="0 0 84 80"
  >
    <g id="Group_3266" data-name="Group 3266" transform="translate(-245 -89)">
      <g
        id="Group_3263"
        data-name="Group 3263"
        transform="translate(-5141 14953)"
      >
        <g
          id="Rectangle_1595"
          data-name="Rectangle 1595"
          transform="translate(5434 -14848)"
          fill="#fbf5eb"
          stroke="#2d323c"
          stroke-width="1"
        >
          <rect width="36" height="64" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="35" height="63" rx="3.5" fill="none" />
        </g>
        <path
          id="Path_981"
          data-name="Path 981"
          d="M134.488,80.074l-6.643,12.774,4.6-1.533a55.878,55.878,0,0,1-7.154,10.219,8.671,8.671,0,0,1-12.263-12.263,56.2,56.2,0,0,1,10.219-7.154l-1.533,4.6,12.774-6.643M116.1,98.46a4.323,4.323,0,1,0,0-6.114,4.324,4.324,0,0,0,0,6.114"
          transform="translate(5329.512 -14921.074)"
          fill="#e0bd78"
          stroke="#2d323c"
          stroke-linecap="round"
          stroke-width="1"
          fill-rule="evenodd"
        />
        <g
          id="Group_3256"
          data-name="Group 3256"
          transform="translate(5165 -15304)"
        >
          <line
            id="Line_459"
            data-name="Line 459"
            x2="22"
            transform="translate(276 510.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
          <line
            id="Line_460"
            data-name="Line 460"
            x2="22"
            transform="translate(276 502.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
        </g>
      </g>
      <g
        id="Group_3264"
        data-name="Group 3264"
        transform="translate(-5189 14953)"
      >
        <g
          id="Rectangle_1595-2"
          data-name="Rectangle 1595"
          transform="translate(5434 -14848)"
          fill="#fcf3f8"
          stroke="#2d323c"
          stroke-width="1"
        >
          <rect width="36" height="64" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="35" height="63" rx="3.5" fill="none" />
        </g>
        <path
          id="Path_981-2"
          data-name="Path 981"
          d="M134.488,80.074l-6.643,12.774,4.6-1.533a55.878,55.878,0,0,1-7.154,10.219,8.671,8.671,0,0,1-12.263-12.263,56.2,56.2,0,0,1,10.219-7.154l-1.533,4.6,12.774-6.643M116.1,98.46a4.323,4.323,0,1,0,0-6.114,4.324,4.324,0,0,0,0,6.114"
          transform="translate(5329.512 -14921.074)"
          fill="#b40068"
          stroke="#2d323c"
          stroke-linecap="round"
          stroke-width="1"
          fill-rule="evenodd"
        />
        <g
          id="Group_3256-2"
          data-name="Group 3256"
          transform="translate(5165 -15304)"
        >
          <line
            id="Line_459-2"
            data-name="Line 459"
            x2="22"
            transform="translate(276 510.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
          <line
            id="Line_460-2"
            data-name="Line 460"
            x2="22"
            transform="translate(276 502.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
        </g>
      </g>
      <g
        id="Rectangle_1597"
        data-name="Rectangle 1597"
        transform="translate(269 91)"
        fill="#fff"
        stroke="#fff"
        stroke-width="2"
      >
        <rect width="36" height="64" rx="4" stroke="none" />
        <rect x="-1" y="-1" width="38" height="66" rx="5" fill="none" />
      </g>
      <g
        id="Group_3262"
        data-name="Group 3262"
        transform="translate(-5165 14939)"
      >
        <g
          id="Path_2186"
          data-name="Path 2186"
          transform="translate(5434 -14848)"
          fill="#e5f8f8"
        >
          <path
            d="M 32 63.5 L 4 63.5 C 2.070090055465698 63.5 0.5 61.92990875244141 0.5 60 L 0.5 4 C 0.5 2.070090055465698 2.070090055465698 0.5 4 0.5 L 32 0.5 C 33.92990875244141 0.5 35.5 2.070090055465698 35.5 4 L 35.5 60 C 35.5 61.92990875244141 33.92990875244141 63.5 32 63.5 Z"
            stroke="none"
          />
          <path
            d="M 4 1 C 2.345790863037109 1 1 2.345790863037109 1 4 L 1 60 C 1 61.65420913696289 2.345790863037109 63 4 63 L 32 63 C 33.65420913696289 63 35 61.65420913696289 35 60 L 35 4 C 35 2.345790863037109 33.65420913696289 1 32 1 L 4 1 M 4 0 L 32 0 C 34.20914077758789 0 36 1.790859222412109 36 4 L 36 60 C 36 62.20914077758789 34.20914077758789 64 32 64 L 4 64 C 1.790859222412109 64 0 62.20914077758789 0 60 L 0 4 C 0 1.790859222412109 1.790859222412109 0 4 0 Z"
            stroke="none"
            fill="#2d323c"
          />
        </g>
        <path
          id="Path_981-3"
          data-name="Path 981"
          d="M134.488,80.074l-6.643,12.774,4.6-1.533a55.878,55.878,0,0,1-7.154,10.219,8.671,8.671,0,0,1-12.263-12.263,56.2,56.2,0,0,1,10.219-7.154l-1.533,4.6,12.774-6.643M116.1,98.46a4.323,4.323,0,1,0,0-6.114,4.324,4.324,0,0,0,0,6.114"
          transform="translate(5329.512 -14921.074)"
          fill="#05b5bc"
          stroke="#2d323c"
          stroke-linecap="round"
          stroke-width="1"
          fill-rule="evenodd"
        />
        <g
          id="Group_3256-3"
          data-name="Group 3256"
          transform="translate(5165 -15304)"
        >
          <line
            id="Line_459-3"
            data-name="Line 459"
            x2="22"
            transform="translate(276 510.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
          <line
            id="Line_460-3"
            data-name="Line 460"
            x2="22"
            transform="translate(276 502.5)"
            fill="none"
            stroke="#2d323c"
            stroke-width="1"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FeatureSubscription',
}
</script>

<style lang="scss" scoped></style>
